import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import { Stack, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

import { ReactComponent as CelebrationSvg } from "../../../assets/celebration.svg"
import { useAppDispatch } from "../../../hooks/useDispatch"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { setShowAccountSetUp } from "../../../redux/preferencesSlice"
import { SUPPRESSED } from "../../../redux/types"
import AppButton from "../../buttons/appButton"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"

/** Displayed when an org has been set up successfully */
const OrgSetUpSuccess = (): ReactElement => {
    const { onSignOut } = useGetUserData()
    const dispatch = useAppDispatch()
    const theme = useTheme()
    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="Set Up Complete!"
            customSvg={
                <CelebrationSvg
                    fill={theme.palette.success.main}
                    viewBox="250 -50 40 700"
                />
            }
            subtitle="Your organization has been successfully set up. You are now the admin of your company. We have sent you an email to confirm all the details."
            content={
                <Stack alignItems="center" width="100%" spacing={12}>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        Click the button below to finish the process. This will
                        sign you out.
                    </Typography>

                    <CheckCircleOutlineIcon
                        sx={{
                            color: theme.palette.success.main,
                            fontSize: "250px",
                        }}
                    />
                </Stack>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <AppButton
                        fullWidth
                        variant="contained"
                        color="success"
                        onClick={() => {
                            onSignOut()
                            dispatch(setShowAccountSetUp(SUPPRESSED))
                        }}
                    >
                        Finish
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default OrgSetUpSuccess
